<template>
  <slot
    name="content"
    :index="index"
    :selectedTypeId="selectedTypeId"
    :controls="controls"
    :toggleTypeOfHome="toggleTypeOfHome"
    :assignHiddenFields="assignHiddenFields"
    :openFullGalleryView="openFullGalleryView"
    :showTour="showTour"
    :toggleEnquiryForm="toggleEnquiryForm"
    :closeLightBox="closeLightBox"
    ></slot>
</template>
<script setup>
import {ref} from 'vue'
import {useFormSubmit} from '../../composables/useFormSubmit'
import {useCommon} from "../../composables/useCommon";
const { assignHiddenFields } = useFormSubmit()
const index = ref(null)
const { openFullGalleryView, showTour } = useCommon(index)
const {toggleEnquiryForm} = useFormSubmit()

const props = defineProps({
  defaultTypeId: {
    type: String,
    default: '',
  },
})

const selectedTypeId = ref(props.defaultTypeId)
const controls = [
  '<i class=\'icon icon--arrow-left\'></i>',
  '<i class=\'icon icon--arrow-right\'></i>'
]

const toggleTypeOfHome = (id) => {
  selectedTypeId.value = id
}

const closeLightBox = () => {
  index.value = null
}
</script>
